import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const MergeCellIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 12H17M8.5 14.5L7 12L8.5 9.5M15.5 14.5L17 12L15.5 9.5M20 20V4M4 20V4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

MergeCellIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(MergeCellIcon);
